<template>
	<div class="p-grid p-fluid vld-parent profile-kyc">
		<loading :active.sync="isLoading" 
        :can-cancel="false" 
        :is-full-page="true"></loading>
		<Toast />

		<div class="p-col-12">
			<div class="card card-w-title">
				<div class="p-grid">
					<div class="p-col-4">
						<Panel header="ID" :toggleable="false">
							<Message v-if="kycData.id.status == ''" severity="info" :closable="false">KYC check is required</Message>
							<Message v-if="kycData.id.status == 'opened'" severity="info" :closable="false">Your KYC check is being processed...</Message>
							<Message v-if="kycData.id.status == 'denied'" severity="error" :closable="false">Your KYC check was not successfull!</Message>
							<Message v-if="kycData.id.status == 'approved'" severity="success" :closable="false">Your KYC check was successfull!</Message>

							<div class="panel-content-body">
								<div class="panel-upload-title">Your images</div>
								<p v-if="kycData.id.status == ''">Please upload a scanned version of your ID, passport or drivers licence</p>

								<div v-for="(document) in userUploads.id" :key="document.document_id" class="card">
									<span>{{document.filename}}</span>
									<!-- <a :href="staticUrl + document.path" target="_blank">
										<img v-if="document.mimetype.indexOf('image') !== -1" :src="staticUrl + document.path" width="150">
										<span v-else>{{staticUrl + document.path}}</span>
									</a> -->
								</div>
								<FileUpload ref="fileUploadID" v-if="kycData.id.status !== 'approved' && kycData.id.status !== 'opened'" v-model="documents.id" mode="advanced" accept="*" :maxFileSize="3000000" />
							</div>
							
							<div v-if="kycData.id.status !== '' && kycData.id.reviewer_note !== ''">
								<div class="panel-upload-note">Reviewer note</div>
								<p>{{ kycData.id.reviewer_note }}</p>
							</div>
						</Panel>
					</div>
					<div class="p-col-4">
						<Panel header="Proof of address" :toggleable="false">
							<Message v-if="kycData.proof_of_address.status == ''" severity="info" :closable="false">KYC check is required</Message>
							<Message v-if="kycData.proof_of_address.status == 'opened'" severity="info" :closable="false">Your KYC check is being processed...</Message>
							<Message v-if="kycData.proof_of_address.status == 'denied'" severity="error" :closable="false">Your KYC check was not successfull!</Message>
							<Message v-if="kycData.proof_of_address.status == 'approved'" severity="success" :closable="false">Your KYC check was successfull!</Message>

							<div class="panel-content-body">
								<div class="panel-upload-title">Your images</div>
								<p v-if="kycData.proof_of_address.status == ''">Please upload a scanned document containing proof of your address (bank statement, utilty bill)</p>
								
								<div v-for="(document) in userUploads.proof_of_address" :key="document.document_id" class="card">
									<span>{{document.filename}}</span>
									<!-- <a :href="staticUrl + document.path" target="_blank">
										<img v-if="document.mimetype.indexOf('image') !== -1" :src="staticUrl + document.path" width="150">
										<span v-else>{{staticUrl + document.path}}</span>
									</a> -->
								</div>
								<FileUpload ref="fileUploadProofOfAddress" v-if="kycData.proof_of_address.status !== 'approved' && kycData.proof_of_address.status !== 'opened'" v-model="documents.proof_of_address" mode="advanced" accept="*" :maxFileSize="3000000" />
							</div>
							
														
							<div v-if="kycData.proof_of_address.status !== '' && kycData.proof_of_address.reviewer_note !== ''">
								<div class="panel-upload-note">Reviewer note</div>
								<p>{{ kycData.proof_of_address.reviewer_note }}</p>
							</div>
						</Panel>
					</div>
					<div class="p-col-4">
						<Panel header="Selfie" :toggleable="false">
							<Message v-if="kycData.selfie.status == ''" severity="info" :closable="false">KYC check is required</Message>
							<Message v-if="kycData.selfie.status == 'opened'" severity="info" :closable="false">Your KYC check is being processed...</Message>
							<Message v-if="kycData.selfie.status == 'denied'" severity="error" :closable="false">Your KYC check was not successfull!</Message>
							<Message v-if="kycData.selfie.status == 'approved'" severity="success" :closable="false">Your KYC check was successfull!</Message>

							<div class="panel-content-body">
								<div class="panel-upload-title">Your images</div>
								<p v-if="kycData.selfie.status == ''">Please upload a photo of yourself holding the document from the KYC ID field</p>
								
								<div v-for="(document) in userUploads.selfie" :key="document.document_id" class="card">
									<span>{{document.filename}}</span>
									<!-- <a :href="staticUrl + document.path" target="_blank">
										<img v-if="document.mimetype.indexOf('image') !== -1" :src="staticUrl + document.path" width="150">
										<span v-else>{{staticUrl + document.path}}</span>
									</a> -->
								</div>
								<FileUpload ref="fileUploadSelfie" v-if="kycData.selfie.status !== 'approved' && kycData.selfie.status !== 'opened'" v-model="documents.selfie"  mode="advanced" accept="*" :maxFileSize="3000000" />
							</div>
							
							<div v-if="kycData.selfie.status !== '' && kycData.selfie.reviewer_note !== ''">
								<div class="panel-upload-note">Reviewer note</div>
								<p>{{ kycData.selfie.reviewer_note }}</p>
							</div>
						</Panel>
					</div>

					<div class="p-col-4">
						<span style="display: inline-flex; align-items:center;">Documents needed for KYC:</span>
						<Button @click="openDocument()" class="btn btn-secondary" icon="pi pi-file-pdf" style="display:inline-flex; margin-left: 10px"/>
					</div>
					<div class="p-col-8">
          				<Button v-if="kycData.id.status !== 'approved' || kycData.proof_of_address.status !== 'approved' || kycData.selfie.status !== 'approved'" @click="initCheck()" label="Submit Documents" />
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import KycService from '../../service/KycService.js';
import UserService from '../../service/UserService.js';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
	data() {
		return {
			kyc: [],
			userUploads: {
				id: [],
				proof_of_address: [],
				selfie: []
			},
			kycData: {
				id: {
					status: '',
					reviewer_note: ''
				},
				proof_of_address: {
					status: '',
					reviewer_note: ''
				},
				selfie: {
					status: '',
					reviewer_note: ''
				}
			},
			documents: {
				id: [],
				proof_of_address: [],
				selfie: []
			},
			apiUrl: process.env.VUE_APP_AUTH_URL + 'api/v1/kyc',
			staticUrl: process.env.VUE_APP_AUTH_URL,
			referralLink: null, 
			name: null, 
			surname: null, 
			email: null,
			isLoading: false
		}
	},
	components: {
		Loading
	},
	created() {
		this.$store.commit('setPageTitle', {pageTitle: 'KYC'});
    this.userService = new UserService()
		this.kycService = new KycService()
		this.getApplicationStatus()
		this.referralLink = process.env.VUE_APP_FRONT_URL + '#/register/?id=' + this.$store.state.currentUser.id
	},
	mounted() {
		if (this.$store.state.currentUser.date_of_birth == null) {
			this.$store.commit('openDialog', {header: 'Personal data missing', body: 'Please fill out empty fields on your profile page before continuing with your KYC check', redirect: 'profile'})
		}
	},
	methods: {
		async initCheck() {
			this.isLoading = true

			const formData = new FormData()

			if (this.$refs.fileUploadID != null && this.$refs.fileUploadID.files != null) {
				this.$refs.fileUploadID.files.forEach(doc => {
					formData.append('id', doc)
				});
			}
			
			if (this.$refs.fileUploadProofOfAddress != null && this.$refs.fileUploadProofOfAddress.files != null) {
				this.$refs.fileUploadProofOfAddress.files.forEach(doc => {
					formData.append('proof_of_address', doc)
				});
			}
			
			if (this.$refs.fileUploadSelfie != null && this.$refs.fileUploadSelfie.files != null) {
				this.$refs.fileUploadSelfie.files.forEach(doc => {
					formData.append('selfie', doc)
				});
			}

			this.kyc = await this.kycService.initCheck(formData)
			
			if (this.kyc.status !== 'none') {
				this.getApplicationStatus()
			}
			this.isLoading = false
			this.$toast.add({ severity: 'success', summary: 'KYC check initiated!', life: 3000 });
		},
		async getApplicationStatus() {
			this.userUploads = {
				id: [],
				proof_of_address: [],
				selfie: []
			}
			this.kyc = await this.kycService.getSelf()
			if (this.kyc.status !== 'none') {
				this.kyc.forEach(document => {
					let document_data = document.path.split('/')
					this.userUploads[document.type].push({
						id: document.id,
						kyc_id: document.kyc_id,
						path: document.path,
						mimetype: document.mimetype,
						filename: [...document_data].pop(),
					})
					if (document.reviewer_note != null) this.kycData[document.type].reviewer_note = document.reviewer_note
					this.kycData[document.type].status = document.status
				});
			}
		},

		openDocument() {
                window.open('https://wealth-net.ag:3000/admin/KYC%20REQUIREMENTS.pdf', '_blank')
            },
	}
}

</script>

<style>
.p-fileupload-buttonbar .p-button:nth-child(2) {
	display: none
}

</style>